import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Router from './Router'; // Ton fichier router.jsx
import Header from './components/Header/Header';
import './App.css';
import Footer from './components/Footer/Footer';
function App() {
  return (
    <BrowserRouter>
      <div className="App">
        {/* On n'affiche le header que si l'utilisateur est connecté */}
        <Header />
        <main>
          <Router />
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
